<template>
    <div class="notice">
        <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
        <me-tabs class="notice-content" v-model="active">
            <me-tab title="模版中心">
                <createTemplate v-if="active===0" :showHeader="false"></createTemplate>
            </me-tab>
            <me-tab title="我的模版">
                <createTemplate v-if="active===1" :showHeader="false" :myLabel="true"></createTemplate>
            </me-tab>
        </me-tabs>
    </div>
</template>
<script>
import { removeClass2 } from '@/util/status-util'
import browser from '@/util/browser'
import createTemplate from './createTemplate'
import NativeApi from 'native-api'
export default {
    name: 'template',
    data() {
        return {
            title: '问卷模板',
            isCustomLeft: false,
            active: 0,
        }
    },
    components: { createTemplate },
    computed: {
        query() {
            return this.$route.query
        },
    },
    created() {
        if (this.$route.query.active) {
            this.active = Number(this.$route.query.active)
        }
        removeClass2('body', 'loading')
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
    },
    mounted() {
        let body = document.body || document.documentElement
        body.style.overflow = 'hidden'
        if (/Android/gi.test(navigator.userAgent)) {
            // 如果是安卓用户，则需要做处理
            NativeApi.register('back', (data, responseCallback) => {
                responseCallback('{preventDefault: true}') // 阻止默认返回事件
                NativeApi.invoke('closeCurrentWebView', null, () => {})
            })
        } else {
            NativeApi.register('back', (data, responseCallback) => {
                responseCallback({ 'preventDefault': true }) // 阻止默认返回事件
                NativeApi.invoke('closeCurrentWebView', null, () => {})
            })
        }
    },
    destroyed() {
        let body = document.body || document.documentElement
        body.style.overflow = 'auto'
    }
}
</script>
<style scoped lang="scss">
    .notice{
        min-height: 100%;
        overflow: hidden;
    }
    ::v-deep .me-tab--active{
        font-size: 0.42667rem;
    }
    ::v-deep .me-tabs__line{
        width: 1.7rem;
    }
    ::v-deep .me-popup--bottom{
        border-radius: .2rem .2rem 0 0;
    }
</style>
